import React from 'react'
import { Link, Outlet, useLocation, useParams } from 'react-router-dom'
import Box from '@mui/material/Box'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import PageHeader from '../../../components/admin/PageHeader'
import StatusBadge from '../../../components/admin/StatusBadge'

export default function TournamentDetailLayout() {
  const { id } = useParams()
  const { pathname } = useLocation()
  const base = `/tournaments/${id}`

  const tabs = [
    { label: 'Overview', to: `${base}/overview` },
    { label: 'Registrations', to: `${base}/registrations` },
    { label: 'Blinds', to: `${base}/blinds` },
    { label: 'Prizes', to: `${base}/prizes` },
    { label: 'Schedule', to: `${base}/schedule` },
  ]

  return (
    <Box>
      <PageHeader
        title={`Tournament ${id}`}
        description="Structure, payouts, and operational controls."
        actions={<StatusBadge label="Scheduled" tone="info" />}
      />
      <Tabs
        value={pathname}
        variant="scrollable"
        scrollButtons="auto"
        sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}
      >
        {tabs.map((t) => (
          <Tab key={t.to} label={t.label} component={Link} to={t.to} value={t.to} />
        ))}
      </Tabs>
      <Outlet />
    </Box>
  )
}
